import { useTranslations } from '@btcdirect/composables';
import { parseLocale } from '@btcdirect/functions';
import { DefaultCurrencies } from '@btcdirect/stores';
import { I18n, IntlNumberFormat, createI18n } from 'vue-i18n';

const FALLBACK_LANGUAGE = 'en';

const NUMBER_FORMATS = {
    crypto: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 8
    },
    fiat: {
        style: 'currency',
        currency: DefaultCurrencies.FIAT,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    },
    number: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
        useGrouping: false
    }
};

/**
 * Create a translator instance
 *
 * @param locale the initial locale to use
 */
export function setupI18n(locale: string): I18n {
    const { language } = parseLocale(locale);

    // Create the i18n instance
    const i18n: I18n = createI18n({
        legacy: false,
        locale: language,
        fallbackLocale: FALLBACK_LANGUAGE,
        fallbackWarn: true,
        numberFormats: getNumberFormats(language)
    });

    // Register the i18n instance
    useTranslations(i18n);

    return i18n;
}

function getNumberFormats(language: string): Record<string, IntlNumberFormat> {
    const numberFormats = {
        [language]: NUMBER_FORMATS
    };

    if (language === FALLBACK_LANGUAGE) {
        return numberFormats;
    }

    numberFormats[FALLBACK_LANGUAGE] = NUMBER_FORMATS;
    return numberFormats;
}
